import "@hotwired/turbo-rails"
import "bootstrap/js/dist/collapse"
import "bootstrap/js/dist/offcanvas"
import Modal from "bootstrap/js/dist/modal"

function galleryLinks(galleryId) {
  return Array.from(document.querySelectorAll(`[data-gallery="${galleryId}"]`))
}

function loadLazyBackground(element) {
  const imageUrl = element.dataset.lazyBackground

  if (!imageUrl) return

  element.style.backgroundImage = `url(${JSON.stringify(imageUrl)})`
  delete element.dataset.lazyBackground
}

function initializeLazyBackgrounds() {
  const elements = document.querySelectorAll("[data-lazy-background]")

  if (!("IntersectionObserver" in window)) {
    elements.forEach(loadLazyBackground)
    return
  }

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) return

      loadLazyBackground(entry.target)
      observer.unobserve(entry.target)
    })
  }, { rootMargin: "300px 0px" })

  elements.forEach((element) => observer.observe(element))
}

function renderLightbox(modalElement, link) {
  const image = modalElement.querySelector(".fv-lightbox__image")
  const caption = modalElement.querySelector(".fv-lightbox__caption")

  image.src = link.href
  image.alt = link.dataset.galleryTitle || ""
  caption.textContent = link.dataset.galleryTitle || ""
  modalElement.dataset.galleryCurrentIndex = link.dataset.galleryIndex || "0"
}

function showLightbox(link) {
  const galleryId = link.dataset.gallery
  const modalElement = document.querySelector(`[data-gallery-lightbox="${galleryId}"]`)

  if (!modalElement) return

  renderLightbox(modalElement, link)
  Modal.getOrCreateInstance(modalElement).show()
}

function stepLightbox(modalElement, direction) {
  const galleryId = modalElement.dataset.galleryLightbox
  const links = galleryLinks(galleryId)

  if (links.length === 0) return

  const currentIndex = Number(modalElement.dataset.galleryCurrentIndex || 0)
  const nextIndex = (currentIndex + direction + links.length) % links.length

  renderLightbox(modalElement, links[nextIndex])
}

document.addEventListener("click", (event) => {
  const link = event.target.closest(".fv-gallery__lightbox-link")

  if (link) {
    event.preventDefault()
    showLightbox(link)
    return
  }

  const navButton = event.target.closest("[data-gallery-prev], [data-gallery-next]")

  if (navButton) {
    const modalElement = navButton.closest("[data-gallery-lightbox]")
    const direction = navButton.hasAttribute("data-gallery-prev") ? -1 : 1

    stepLightbox(modalElement, direction)
  }
})

document.addEventListener("keydown", (event) => {
  const modalElement = document.querySelector(".fv-lightbox.show")

  if (!modalElement) return

  if (event.key === "ArrowLeft") {
    stepLightbox(modalElement, -1)
  } else if (event.key === "ArrowRight") {
    stepLightbox(modalElement, 1)
  }
})

document.addEventListener("hidden.bs.offcanvas", () => {
  if (document.querySelector(".offcanvas.show, .modal.show")) return

  document.querySelectorAll(".offcanvas-backdrop").forEach((backdrop) => {
    backdrop.remove()
  })
})

document.addEventListener("turbo:load", initializeLazyBackgrounds)
